module.exports = __webpack_public_path__ + "static/media/foodbev_logo.2fd94780.png";